<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Settings')"
    width="600px"
    :close-on-click-modal="false"
    class="details-view"
    style="overflow: auto;margin-top: 100px;"
  >
    <div class="main-content" style="height: 200px;overflow: auto;">
      <el-form label-width="130px" style="width: 502px;margin-top: 10px;">
        <el-form-item :label="$t('CargoMsg.Cargo_ApplicationScope')">
          <div style="width: 100%;display: flex; align-items: center;">
            <el-checkbox v-model="form.useHqSet" :disabled="readonly" style="padding-left: 2px;">
              <span>{{ $t('CargoMsg.Cargo_GeneralSettings') }}</span>
            </el-checkbox>
          </div>
        </el-form-item>
      </el-form>
      <div style="margin-top: 10px;">
        <div style="display: flex;">
          <el-form label-width="130px" style="width: 502px;" :disabled="form.useHqSet && branchId !== 1">
            <el-form-item :label="$t('CargoMsg.Cargo_BasicPaymentRequest')">
              <el-checkbox v-model="form.openUiCustom" style="padding-left: 2px;" @change="openCustomClick">{{ $t('CargoMsg.Cargo_EnableUICustomization') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AdditionalApprovalNode')">
              <el-checkbox v-model="form.departmentApproval" :disabled="!form.openUiCustom" style="padding-left: 2px;">{{ $t('CargoMsg.Cargo_DepartmentApprovalTab') }}</el-checkbox>
              <el-checkbox v-model="form.supervisorApproval" :disabled="!form.openUiCustom" style="padding-left: 2px;">{{ $t('CargoMsg.Cargo_SupervisorApprovalTab') }}</el-checkbox>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="okHandler">{{ $t('Message.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getBillPaymentSetting, saveBillPaymentSetting } from '@/api/sysManage/uiCustom'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'BillPaymentSettingDialog',
  props: {
    visible: { type: Boolean, required: true },
    pageType: { type: Number, required: true },
    branchId: { type: Number, required: true },
    lob: { type: String, required: true },
    readonly: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: false,
      TYPE_NAMES,
      form: {},
      isEdit: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.form.useHqSet = true // 默认总部设置
          this.form = await getBillPaymentSetting({ pageType: this.pageType, branchId: this.branchId, useHqSet: this.form.useHqSet }).then(res => res.data)
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.form = {}
      }
    }
  },
  methods: {
    okHandler() {
      if (this.readonly) {
        this.innerVisible = false
        return
      }
      this.form.branchId = this.branchId
      const loading = getLoading4Cxt(this)
      saveBillPaymentSetting(this.form).then(() => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    },
    openCustomClick() {
      if (!this.form.openUiCustom) {
        this.form.departmentApproval = false
        this.form.supervisorApproval = false
      }
    }
  }
}
</script>
